import { render, staticRenderFns } from "./AdminCreateFaq.vue?vue&type=template&id=3954bc92&scoped=true&"
import script from "./AdminCreateFaq.vue?vue&type=script&lang=js&"
export * from "./AdminCreateFaq.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreateFaq.vue?vue&type=style&index=0&id=3954bc92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3954bc92",
  null
  
)

export default component.exports